import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faTrash, faSync, faEye, faArrowUp, faArrowDown, 
    faFileExcel, faFilePdf, faSearch, faReceipt,
    faClock, faUtensils, faPlay, faPause
} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './PedidosData.css';
import baseURL from '../../url';
import moneda from '../../moneda';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import contador from '../../contador';

export default function PedidosData() {
    const [pedidos, setPedidos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoEstado, setNuevoEstado] = useState('');
    const [pedido, setPedido] = useState({});
    const [mesas, setMesas] = useState([]);
    const [filtroId, setFiltroId] = useState('');
    const [filtroMesa, setFiltroMesa] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroDesde, setFiltroDesde] = useState('');
    const [filtroHasta, setFiltroHasta] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [numeroTelefono, setNumeroTelefono] = useState('');
    const [counter, setCounter] = useState(contador || 30);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        cargarPedidos();
        cargarMesas();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isPaused) {
                setCounter((prevCounter) => {
                    if (prevCounter <= 1) {
                        cargarPedidos();
                        cargarMesas();
                        return contador || 30;
                    }
                    return prevCounter - 1;
                });
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [isPaused]);

    const cargarMesas = () => {
        fetch(`${baseURL}/mesaGet.php`)
            .then(res => res.json())
            .then(data => setMesas(data.mesas || []))
            .catch(err => console.error('Error al cargar mesas:', err));
    };

    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidoGet.php`)
            .then(res => res.json())
            .then(data => {
                const list = data.pedidos ? [...data.pedidos].reverse() : [];
                setPedidos(list);
            })
            .catch(err => console.error('Error al cargar pedidos:', err));
    };

    const eliminar = (idPedido) => {
        Swal.fire({
            title: '¿Eliminar pedido?',
            text: `Se eliminará el pedido #${idPedido} de forma permanente.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/pedidoDelete.php?idPedido=${idPedido}`, {
                    method: 'DELETE',
                })
                    .then(res => res.json())
                    .then(data => {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarPedidos();
                    })
                    .catch(err => {
                        console.error('Error al eliminar:', err);
                        toast.error('Error al eliminar el pedido');
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setPedido(item);
        setNuevoEstado(item.estado);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = (idPedido) => {
        const payload = {
            estado: nuevoEstado !== '' ? nuevoEstado : pedido.estado,
        };

        fetch(`${baseURL}/pedidoPut.php?idPedido=${idPedido}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Actualizado', data.mensaje || 'Pedido actualizado', 'success');
                    cargarPedidos();
                    cerrarModal();
                }
            })
            .catch(err => toast.error(err.message));
    };

    const invertirOrden = () => {
        setPedidos([...pedidos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };

    const filtrados = pedidos.filter(item => {
        const idMatch = !filtroId || item.idPedido.toString().includes(filtroId);
        const mesaMatch = !filtroMesa || (item.idMesa && item.idMesa.toString() === filtroMesa.toString());
        const estadoMatch = !filtroEstado || item.estado?.toLowerCase() === filtroEstado.toLowerCase();
        const desdeMatch = !filtroDesde || new Date(item.createdAt) >= new Date(filtroDesde);
        
        let hastaMatch = true;
        if (filtroHasta) {
            const adjustedHasta = new Date(filtroHasta);
            adjustedHasta.setDate(adjustedHasta.getDate() + 1);
            hastaMatch = new Date(item.createdAt) < adjustedHasta;
        }

        return idMatch && mesaMatch && estadoMatch && desdeMatch && hastaMatch;
    });

    const descargarExcel = () => {
        let totalGeneral = 0;
        const data = filtrados.map(item => {
            const total = parseFloat(item.total) || 0;
            totalGeneral += total;
            let infoProductos = '';
            try {
                const prods = JSON.parse(item.productos);
                infoProductos = prods.map(p => `${p.titulo} - ${moneda}${p.precio} x${p.cantidad}`).join('\n');
            } catch(e) {}

            return {
                'ID Pedido': item.idPedido,
                'Mesa': mesas.find(m => m.idMesa === item.idMesa)?.mesa || 'Llevar / Tienda',
                'Estado': item.estado,
                'Nombre': item.nombre || '-',
                'Nota': item.nota || '-',
                'Productos': infoProductos,
                'Cupón': item.codigo || '-',
                'Total': `${moneda} ${total.toFixed(2)}`,
                'Fecha': item.createdAt,
            };
        });

        data.push({
            'ID Pedido': '',
            'Mesa': '',
            'Estado': '',
            'Nombre': '',
            'Nota': '',
            'Productos': '',
            'Cupón': 'Total General:',
            'Total': `${moneda} ${totalGeneral.toFixed(2)}`,
            'Fecha': '',
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Pedidos');
        XLSX.writeFile(wb, 'pedidos.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF('landscape');
        pdf.text('Reporte de Pedidos', 14, 12);

        const columns = [
            { title: 'ID', dataKey: 'idPedido' },
            { title: 'Mesa', dataKey: 'mesa' },
            { title: 'Estado', dataKey: 'estado' },
            { title: 'Cliente', dataKey: 'nombre' },
            { title: 'Productos', dataKey: 'productos' },
            { title: 'Cupón', dataKey: 'codigo' },
            { title: 'Total', dataKey: 'total' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        let totalGeneral = 0;
        const data = filtrados.map(item => {
            const total = parseFloat(item.total) || 0;
            totalGeneral += total;
            let infoProductos = '';
            try {
                const prods = JSON.parse(item.productos);
                infoProductos = prods.map(p => `${p.titulo} x${p.cantidad}`).join(', ');
            } catch(e) {}

            return {
                idPedido: item.idPedido,
                mesa: mesas.find(m => m.idMesa === item.idMesa)?.mesa || 'Llevar / Tienda',
                estado: item.estado,
                nombre: item.nombre || '-',
                productos: infoProductos,
                codigo: item.codigo || '-',
                total: `${moneda} ${total.toFixed(2)}`,
                createdAt: item.createdAt,
            };
        });

        pdf.autoTable({
            startY: 18,
            columns: columns,
            body: [
                ...data,
                { idPedido: '', mesa: '', estado: '', nombre: '', productos: '', codigo: 'Total:', total: `${moneda} ${totalGeneral.toFixed(2)}`, createdAt: '' }
            ],
        });

        pdf.save('reporte_pedidos.pdf');
    };

    const handleDownloadIndividualPDF = () => {
        if (!pedido || !pedido.idPedido) return;
        const pdf = new jsPDF();
        pdf.text(`Detalle de Pedido #${pedido.idPedido}`, 14, 15);
        const mesaObj = mesas.find(m => m.idMesa === pedido.idMesa);

        const pedidoData = [
            ['ID Pedido:', `${pedido.idPedido}`],
            ['Mesa:', `${mesaObj ? mesaObj.mesa : 'Llevar / Tienda'}`],
            ['Estado:', `${pedido.estado}`],
            ['Cliente:', `${pedido.nombre || 'No especificado'}`],
            ['Nota:', `${pedido.nota || '-'}`],
            ['Cupón:', `${pedido.codigo || '-'}`],
            ['Total:', `${moneda} ${pedido.total}`],
            ['Fecha:', `${pedido.createdAt}`]
        ];

        pdf.autoTable({
            startY: 22,
            head: [['Detalle', 'Información']],
            body: pedidoData,
        });

        pdf.save(`pedido_${pedido.idPedido}.pdf`);
    };

    const handleEnviarWhatsApp = (ped) => {
        if (!numeroTelefono) {
            toast.warn('Ingresa un número de WhatsApp');
            return;
        }

        let mensaje = `*Detalle de Pedido #${ped?.idPedido}*\nCliente: ${ped?.nombre || 'Estimado(a)'}\n`;
        try {
            const prods = typeof ped.productos === 'string' ? JSON.parse(ped.productos) : ped.productos;
            if (Array.isArray(prods)) {
                mensaje += `--------------------------\n`;
                prods.forEach(p => {
                    mensaje += `• ${p.titulo} - ${moneda}${p.precio} x${p.cantidad}\n`;
                });
                mensaje += `--------------------------\n`;
            }
        } catch(e) {}
        mensaje += `*Total: ${moneda} ${ped?.total}*`;

        const phoneClean = numeroTelefono.replace(/\D/g, '');
        const url = `https://api.whatsapp.com/send?phone=${phoneClean}&text=${encodeURIComponent(mensaje)}`;
        window.open(url, '_blank');
    };

    // KPIs rápidos
    const totalPedidos = pedidos.length;
    const pedidosPendientes = pedidos.filter(p => p.estado === 'Pendiente').length;
    const pedidosPagados = pedidos.filter(p => p.estado === 'Pagado').length;
    const pedidosEntregados = pedidos.filter(p => p.estado === 'Entregado').length;

    const renderBadgeEstado = (estado) => {
        const est = (estado || '').toLowerCase();
        let badgeClass = 'badgeGeneral';
        if (est.includes('pendiente')) badgeClass = 'badgePendiente';
        else if (est.includes('pagado')) badgeClass = 'badgePagado';
        else if (est.includes('entregado') || est.includes('listo')) badgeClass = 'badgeEntregado';
        else if (est.includes('rechazado') || est.includes('cancelado')) badgeClass = 'badgeRechazado';
        else if (est.includes('preparacion') || est.includes('cocina')) badgeClass = 'badgePreparacion';

        return <span className={`adminBadge ${badgeClass}`}>{estado}</span>;
    };

    return (
        <div className="adminPageContainer">
            <ToastContainer />

            {/* Cabecera Principal */}
            <div className="adminHeaderSection">
                <div className="adminHeaderTitle">
                    <h2><FontAwesomeIcon icon={faReceipt} /> Gestión de Pedidos</h2>
                    <p>Administra los pedidos de mesas, compras en tienda y punto de venta en tiempo real.</p>
                </div>
                <div className="adminHeaderActions">
                    <div className="countdownAutoReload" title="Tiempo para auto-actualización">
                        <FontAwesomeIcon icon={faClock} />
                        <span>{counter}s</span>
                        <button className="btnPlayPause" onClick={() => setIsPaused(!isPaused)}>
                            <FontAwesomeIcon icon={isPaused ? faPlay : faPause} />
                        </button>
                    </div>

                    <button className="adminExportBtn btnExcel" onClick={descargarExcel} title="Exportar a Excel">
                        <FontAwesomeIcon icon={faFileExcel} /> Excel
                    </button>
                    <button className="adminExportBtn btnPdf" onClick={descargarPDF} title="Exportar a PDF">
                        <FontAwesomeIcon icon={faFilePdf} /> PDF
                    </button>
                    <button className="adminActionBtn" onClick={() => { cargarPedidos(); cargarMesas(); }} title="Recargar pedidos">
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                </div>
            </div>

            {/* KPIs Operativos */}
            <div className="adminKpisMiniGrid">
                <div className="adminKpiMiniCard">
                    <span>Total Pedidos</span>
                    <strong>{totalPedidos}</strong>
                </div>
                <div className="adminKpiMiniCard kpiWarning">
                    <span>Pendientes</span>
                    <strong>{pedidosPendientes}</strong>
                </div>
                <div className="adminKpiMiniCard kpiSuccess">
                    <span>Pagados</span>
                    <strong>{pedidosPagados}</strong>
                </div>
                <div className="adminKpiMiniCard kpiInfo">
                    <span>Entregados</span>
                    <strong>{pedidosEntregados}</strong>
                </div>
            </div>

            {/* Barra de Filtros y Búsqueda */}
            <div className="adminToolbar">
                <div className="adminSearchBox">
                    <FontAwesomeIcon icon={faSearch} />
                    <input 
                        type="text" 
                        placeholder="Buscar por ID de pedido..." 
                        value={filtroId} 
                        onChange={(e) => setFiltroId(e.target.value)} 
                    />
                </div>

                <div className="adminFiltersRow">
                    <select value={filtroMesa} onChange={(e) => setFiltroMesa(e.target.value)}>
                        <option value="">Todas las Mesas</option>
                        {mesas.map(m => (
                            <option key={m.idMesa} value={m.idMesa}>{m.mesa}</option>
                        ))}
                    </select>

                    <select value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                        <option value="">Todos los Estados</option>
                        <option value="Pendiente">Pendiente</option>
                        <option value="En preparación">En preparación</option>
                        <option value="Listo">Listo</option>
                        <option value="Entregado">Entregado</option>
                        <option value="Pagado">Pagado</option>
                        <option value="Rechazado">Rechazado</option>
                    </select>

                    <div className="dateFilterItem">
                        <small>Desde</small>
                        <input type="date" value={filtroDesde} onChange={(e) => setFiltroDesde(e.target.value)} />
                    </div>

                    <div className="dateFilterItem">
                        <small>Hasta</small>
                        <input type="date" value={filtroHasta} onChange={(e) => setFiltroHasta(e.target.value)} />
                    </div>

                    <button className="adminActionBtn" onClick={invertirOrden} title="Invertir orden de fecha">
                        <FontAwesomeIcon icon={ordenInvertido ? faArrowUp : faArrowDown} />
                    </button>
                </div>
            </div>

            {/* Tabla de Pedidos */}
            <div className="adminTableCard">
                <div className="adminTableResponsive">
                    <table className="adminTable">
                        <thead>
                            <tr>
                                <th># ID</th>
                                <th>Mesa / Origen</th>
                                <th>Cliente</th>
                                <th>Estado</th>
                                <th>Cupón</th>
                                <th>Total</th>
                                <th>Fecha y Hora</th>
                                <th style={{ textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtrados.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="adminEmptyRow">
                                        No se encontraron pedidos con los filtros aplicados.
                                    </td>
                                </tr>
                            ) : (
                                filtrados.map(item => {
                                    const mesaMatch = mesas.find(m => m.idMesa === item.idMesa);
                                    return (
                                        <tr key={item.idPedido}>
                                            <td><strong>#{item.idPedido}</strong></td>
                                            <td>
                                                {mesaMatch ? (
                                                    <span className="mesaBadgeTag">
                                                        <FontAwesomeIcon icon={faUtensils} /> {mesaMatch.mesa}
                                                    </span>
                                                ) : (
                                                    <span className="mesaBadgeTag tagTienda">Tienda / POS</span>
                                                )}
                                            </td>
                                            <td>{item.nombre || <span className="textMuted">-</span>}</td>
                                            <td>{renderBadgeEstado(item.estado)}</td>
                                            <td>{item.codigo ? <span className="cuponBadge">{item.codigo}</span> : '-'}</td>
                                            <td><strong className="precioVerde">{moneda} {parseFloat(item.total).toFixed(2)}</strong></td>
                                            <td><span className="fechaSpan">{item.createdAt}</span></td>
                                            <td>
                                                <div className="adminActionBtnGroup" style={{ justifyContent: 'center' }}>
                                                    <button 
                                                        className="btnTableAction btnVer" 
                                                        onClick={() => abrirModal(item)} 
                                                        title="Ver detalles del pedido"
                                                    >
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </button>
                                                    <button 
                                                        className="btnTableAction btnBorrar" 
                                                        onClick={() => eliminar(item.idPedido)} 
                                                        title="Eliminar pedido"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal Detalle de Pedido */}
            {modalVisible && pedido && (
                <div className="adminModalOverlay">
                    <div className="adminModalContent modalPedidoDetail">
                        <div className="adminModalHeader">
                            <h3>Detalle del Pedido #{pedido.idPedido}</h3>
                            <button className="adminModalClose" onClick={cerrarModal}>&times;</button>
                        </div>

                        <div className="adminModalBody">
                            <div className="pedidoModalMetaGrid">
                                <div>
                                    <label>Mesa / Destino</label>
                                    <strong>{mesas.find(m => m.idMesa === pedido.idMesa)?.mesa || 'Tienda / Para llevar'}</strong>
                                </div>
                                <div>
                                    <label>Cliente</label>
                                    <strong>{pedido.nombre || 'No indicado'}</strong>
                                </div>
                                <div>
                                    <label>Fecha</label>
                                    <span>{pedido.createdAt}</span>
                                </div>
                                <div>
                                    <label>Cupón aplicado</label>
                                    <span>{pedido.codigo || 'Ninguno'}</span>
                                </div>
                            </div>

                            {pedido.nota && (
                                <div className="pedidoModalNota">
                                    <strong>Observaciones:</strong> {pedido.nota}
                                </div>
                            )}

                            {/* Lista de Productos del Pedido */}
                            <div className="pedidoModalProdsList">
                                <h4>Productos ({(() => {
                                    try { return JSON.parse(pedido.productos).length; } catch(e) { return 0; }
                                })()})</h4>
                                
                                <div className="pedidoProdsScroll">
                                    {(() => {
                                        try {
                                            const prods = JSON.parse(pedido.productos);
                                            return prods.map((prod, idx) => (
                                                <div key={idx} className="pedidoProdItemRow">
                                                    {prod.imagen ? (
                                                        <img src={prod.imagen} alt={prod.titulo} className="pedidoProdThumb" />
                                                    ) : (
                                                        <div className="pedidoProdThumbEmpty"><FontAwesomeIcon icon={faUtensils} /></div>
                                                    )}
                                                    <div className="pedidoProdItemInfo">
                                                        <strong>{prod.titulo}</strong>
                                                        <small>{prod.item || ''}</small>
                                                    </div>
                                                    <div className="pedidoProdItemPrice">
                                                        <span>x{prod.cantidad}</span>
                                                        <strong>{moneda} {prod.precio}</strong>
                                                    </div>
                                                </div>
                                            ));
                                        } catch (e) {
                                            return <p className="textMuted">No se pudieron leer los productos.</p>;
                                        }
                                    })()}
                                </div>
                            </div>

                            {/* Total y Cambio de Estado */}
                            <div className="pedidoModalFooterRow">
                                <div className="pedidoModalTotal">
                                    <span>Total a Pagar:</span>
                                    <strong>{moneda} {parseFloat(pedido.total).toFixed(2)}</strong>
                                </div>

                                <div className="pedidoModalStatusSelector">
                                    <label>Estado del Pedido:</label>
                                    <select
                                        value={nuevoEstado !== '' ? nuevoEstado : pedido.estado}
                                        onChange={(e) => setNuevoEstado(e.target.value)}
                                    >
                                        <option value="Pendiente">Pendiente</option>
                                        <option value="En preparación">En preparación</option>
                                        <option value="Listo">Listo</option>
                                        <option value="Entregado">Entregado</option>
                                        <option value="Pagado">Pagado</option>
                                        <option value="Rechazado">Rechazado</option>
                                    </select>
                                </div>
                            </div>

                            {/* Enviar WhatsApp */}
                            <div className="pedidoWppBox">
                                <label>Notificar al cliente por WhatsApp:</label>
                                <div className="wppInputRow">
                                    <input 
                                        type="text" 
                                        placeholder="Ej: +5491123456789" 
                                        value={numeroTelefono} 
                                        onChange={(e) => setNumeroTelefono(e.target.value)} 
                                    />
                                    <button className="btnSendWppAction" onClick={() => handleEnviarWhatsApp(pedido)}>
                                        Enviar Detalle
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="adminModalFooter">
                            <button className="adminBtnSecondary" onClick={handleDownloadIndividualPDF}>
                                <FontAwesomeIcon icon={faFilePdf} /> Descargar PDF
                            </button>
                            <button className="adminBtnPrimary" onClick={() => handleUpdateText(pedido.idPedido)}>
                                Guardar Cambios
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
